import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../util/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Usuario } from '../../../models/usuario/usuario';
import { Produto, CategoriaComplemento, Complemento } from '../../../models/produto/produto';

const API_URL = environment.apiUrl;
const API_URL_BASE = environment.apiBaseUrl;


@Injectable({
  providedIn: 'root'
})
export class ProdutoService {
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('ProdutoService');
  }

  listarCarregoria(): Observable<any> {
    return this.http.get<any>(API_URL + '/category/list')
      .pipe(
        catchError(this.handleError('listarCarregoria', []))
      );
  }

  cadastrarProduto(produto: Produto): Observable<any> {
    return this.http.post<Produto>(API_URL + 'product', produto)
      .pipe(
        catchError(this.handleError('cadastrarProduto', produto))
      );
  }
  update_categoria_produto(record: CategoriaComplemento): Observable<any> {
    return this.http.put<CategoriaComplemento>(API_URL + 'product/categorycomplement', record)
      .pipe(
        catchError(this.handleError('cadastrarProduto', record))
      );
  }

  create_categoria_produto(record: CategoriaComplemento): Observable<any> {
    return this.http.post<CategoriaComplemento>(API_URL + 'product/categorycomplement', record)
      .pipe(
        catchError(this.handleError('cadastrarProduto', record))
      );
  }
  remover_categoria_produto(id): Observable<any> {
    return this.http.delete<any>(API_URL + `product/categorycomplement/${id}`)
      .pipe(
        catchError(this.handleError('detalharProduto', []))
      );
  }
  create_complemento_produto(record: CategoriaComplemento): Observable<any> {
    return this.http.post<Complemento>(API_URL + 'product/complement', record)
      .pipe(
        catchError(this.handleError('cadastrarProduto', record))
      );
  }
  update_complemento_produto(record: CategoriaComplemento): Observable<any> {
    return this.http.put<Complemento>(API_URL + 'product/complement', record)
      .pipe(
        catchError(this.handleError('cadastrarProduto', record))
      );
  }
  remover_complemento_produto(id): Observable<any> {
    return this.http.delete<any>(API_URL + `product/complement/${id}`)
      .pipe(
        catchError(this.handleError('detalharProduto', []))
      );
  }
  consultarProduto(): Observable<any> {
    return this.http.get<any>(API_URL + '/product')
      .pipe(
        catchError(this.handleError('consultarProduto', []))
      );
  }
  detalharProduto(id): Observable<any> {
    return this.http.get<any>(API_URL + `/product/${id}`)
      .pipe(
        catchError(this.handleError('detalharProduto', []))
      );
  }
}
